import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '@/styles'
import Edit from './edit'
import Options from './options'
import View from './view'
import { TextButton, BackButton } from '../buttons'
import { useAddendumModal } from '../context'
import ModalBase from '../modal-base'

const EditAddendum = () => {
  const { t } = useTranslation()
  const {
    close,
    backStep,
    isAdmin,
    addendum,
    addendumType,
    titleText,
    isEditing,
    onDelete,
    onDeleteComplete
  } = useAddendumModal()
  const [editing, setEditing] = useState(isEditing)
  const [addendumState, setAddendumState] = useState(addendum)
  const isOptionsAddendum = addendum?.data_type === 'options'
  const isNew = typeof addendum === 'undefined'

  const isEditable = addendumType !== 'standard'

  const deleteCompleteAction = () => {
    if (onDeleteComplete === 'close') return close()
    if (onDeleteComplete === 'back') return backStep()
    return
  }

  const handleDelete = async () => {
    await onDelete(addendumState)
    deleteCompleteAction()
  }

  const getRightWidget = () => {
    if (!editing && isEditable && isAdmin)
      return <TextButton onClick={() => setEditing(true)}>{t('common.edit', 'Edit')}</TextButton>
    if (editing && onDelete) {
      return (
        <TextButton delete onClick={handleDelete}>
          {addendumType === 'one_time'
            ? t('common.remove', 'Remove')
            : t('common.delete', 'Delete')}
        </TextButton>
      )
    }
    return null
  }

  const title = editing ? titleText || addendumState?.title : addendumState?.title

  return (
    <>
      {isOptionsAddendum ? (
        <Options />
      ) : (
        <ModalBase
          leftWidget={
            <BackButton
              back={
                editing && isEditable && addendumType === 'company' && !isNew
                  ? () => setEditing(false)
                  : backStep
              }
            />
          }
          rightWidget={getRightWidget()}
          title={title}
          backgroundColor={colors.white}
        >
          {editing ? (
            <Edit
              setEditing={setEditing}
              addendumState={addendumState}
              setAddendumState={setAddendumState}
            />
          ) : (
            <View addendumState={addendumState} />
          )}
        </ModalBase>
      )}
    </>
  )
}

export default EditAddendum
